import { Injectable } from '@angular/core';
import { gql, Query } from 'apollo-angular';

import { Query as RootQuery } from 'graphql/models/generated';

export const ACCOUNT_PREFERENCES_QUERY = gql`
  query accountPreferences($where: AccountPreferencesWhereInput!) {
    accountPreferences(where: $where) {
      id
      accountId
      type
      key
      name
      value
    }
  }
`;

@Injectable({
  providedIn: 'root'
})

export class AccountPreferencesQuery extends Query<RootQuery> {
  document = ACCOUNT_PREFERENCES_QUERY;
}
